import React from "react"
import { VictoryPie } from "victory"
import {
  GraphContainer,
  GraphWrapper,
  PieGraphList,
  PieGraphListItem,
  PieGraphListDot,
  ParagraphText,
  PieGraphContainer,
} from "../../UIKit/styles"

function PieGraph({ data }) {
  const filteredData = data[1].filter((obj) => obj.x !== "Total")

  const getPercentageOfTotal = (datum) => {
    const totalValue = data[1].find((obj) => obj.x === "Total").y
    return Math.round((datum / totalValue) * 100)
  }

  const Label = (props) => {
    const { text, x, y, datum } = props
    const angle = (datum.startAngle + datum.endAngle) / 2
    const textAnchor = angle <= 180 ? "start" : "end"
    return (
      <g>
        <text
          x={x}
          y={y}
          fill="#000"
          textAnchor={textAnchor}
          dominantBaseline="middle"
          fontSize={8}
        >
          {text}
        </text>
      </g>
    )
  }

  const colors = [
    "#F44336",
    "#9C27B0",
    "#673AB7",
    "#3F51B5",
    "#2196F3",
    "#00BCD4",
    "#4CAF50",
    "#8BC34A",
    "#FFEB3B",
    "#FF9800",
  ]

  const getGraphFill = ({ datum }) => {
    switch (datum.x) {
      case "Fuel":
        return colors[0]
      case "Electricity":
        return colors[1]
      case "Fertiliser manufacture":
        return colors[2]
      case "Compost manufacture":
        return colors[3]
      case "Agrichemicals":
        return colors[4]
      case "Capital (pergola & netting)":
        return colors[5]
      case "Waste & recycling":
        return colors[6]
      case "Soil emissions - pruning & leaves":
        return colors[7]
      case "Soil emissions - compost":
        return colors[8]
      case "Soil emissions - fertilisers":
        return colors[9]
      default:
        return "#000000"
    }
  }

  const getLegend = (data) => {
    const legendData = data.map((datum) => {
      return {
        name: `${datum.x}: ${getPercentageOfTotal(datum.y)}%`,
        color: getGraphFill({ datum }),
      }
    })
    return (
      <PieGraphList>
        {legendData.map((data) => (
          <PieGraphListItem key={data.name}>
            <PieGraphListDot color={data.color} />
            <ParagraphText style={{ color: "#000" }}>{data.name}</ParagraphText>
          </PieGraphListItem>
        ))}
      </PieGraphList>
    )
  }

  return (
    <GraphWrapper>
      <GraphContainer>
        <PieGraphContainer>
          <VictoryPie
            data={filteredData}
            height={300}
            labelRadius={105}
            
            labels={({ datum }) => `${datum.x}: ${getPercentageOfTotal(datum.y)}%`}
            labelComponent={<Label />}
            style={{
              data: {
                stroke: "white",
                strokeWidth: 1,
                fill: getGraphFill,
              },
            }}
          />
        
        </PieGraphContainer>
      </GraphContainer>
    </GraphWrapper>
  )
}

export default PieGraph
